import { render, staticRenderFns } from "./HotelPage.vue?vue&type=template&id=6befb6e2&"
import script from "./HotelPage.vue?vue&type=script&lang=js&"
export * from "./HotelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports